// A surface drawn over the board, such as a student's exam sheet, owns the Trang pager while it
// shows, so the pager never steps the hidden document underneath.

import { useEffect } from 'react';
import { create } from 'zustand';

export interface PagerOverride {
  index: number;
  count: number;
  go: (index: number) => void;
}

interface PagerOverrideState {
  pager: PagerOverride | null;
}

export const usePagerOverrideStore = create<PagerOverrideState>(() => ({ pager: null }));

/** Hands the Trang pager to the caller while `pager` is set; memoize it, a new object re-registers. */
export function useOwnPager(pager: PagerOverride | null): void {
  useEffect(() => {
    if (!pager) return undefined;
    usePagerOverrideStore.setState({ pager });
    return () => {
      if (usePagerOverrideStore.getState().pager === pager) usePagerOverrideStore.setState({ pager: null });
    };
  }, [pager]);
}
